import React from 'react';
import {components} from 'react-select';

export const DefaultOption = ({children, ...props}) => {
  const {onMouseMove, onMouseOver, ...rest} = props.innerProps;
  const newProps = {...props, innerProps: rest};

  return (
    <components.Option {...newProps} className="custom-option">
      {children}
    </components.Option>
  );
};
